(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var mq = window.matchMedia('(max-width: 899px)');

  document.querySelectorAll('.alive-gallery__row').forEach(function (row) {
    var count = parseInt(row.dataset.count, 10);
    if (!count) return;

    var cells = row.children;
    var index = 0;
    var timer = null;
    var resetTimer = null;

    function goTo(i, smooth) {
      var cell = cells[i];
      if (!cell) return;
      row.scrollTo({ left: cell.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    }

    function advance() {
      if (!mq.matches || !cells.length) return;
      index += 1;
      goTo(index, true);

      if (index >= count) {
        clearTimeout(resetTimer);
        resetTimer = setTimeout(function () {
          index = 0;
          goTo(0, false);
        }, 550);
      }
    }

    function start() {
      stop();
      timer = setInterval(advance, 3200);
    }

    function stop() {
      if (timer) clearInterval(timer);
      clearTimeout(resetTimer);
    }

    row.addEventListener('touchstart', stop, { passive: true });
    row.addEventListener('touchend', function () {
      setTimeout(start, 3000);
    }, { passive: true });

    start();
  });
})();
